"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var store_1 = require("@ngrx/store");
var idm_frontend_shared_1 = require("@synisys/idm-frontend-shared");
var skynet_store_currencies_api_1 = require("@synisys/skynet-store-currencies-api");
var skynet_store_utilities_1 = require("@synisys/skynet-store-utilities");
var lodash_1 = require("lodash");
var combineLatest_1 = require("rxjs/observable/combineLatest");
var of_1 = require("rxjs/observable/of");
var operators_1 = require("rxjs/operators");
var Subject_1 = require("rxjs/Subject");
var currency_control_state_1 = require("../../currency-control.state");
var utilities_1 = require("../../utilities");
var rate_input_component_1 = require("./_rate-input/rate-input.component");
var SisRateComponent = /** @class */ (function () {
    // </editor-fold>
    function SisRateComponent(store, formattingService, translationService, cd) {
        this.store = store;
        this.formattingService = formattingService;
        this.translationService = translationService;
        this.cd = cd;
        this.destructionSubject = new Subject_1.Subject();
        this.logger = utilities_1.createLogger('sis-rate');
    }
    Object.defineProperty(SisRateComponent.prototype, "id", {
        // <editor-fold desc="getters and setters">
        set: function (value) {
            this._id = value;
            this.logger = utilities_1.createLogger('sis-rate:' + this._id);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisRateComponent.prototype, "rateDateReadOnly", {
        get: function () {
            return this._rateDateReadOnly;
        },
        set: function (value) {
            this._rateDateReadOnly = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisRateComponent.prototype, "rateReadOnly", {
        get: function () {
            return this._rateReadOnly;
        },
        set: function (value) {
            this._rateReadOnly = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisRateComponent.prototype, "rateLabel", {
        get: function () {
            return this._rateLabel;
        },
        set: function (value) {
            if (value) {
                this._rateLabel = skynet_store_utilities_1.deserializeMultilingual(value);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisRateComponent.prototype, "dateLabel", {
        get: function () {
            return this._dateLabel;
        },
        set: function (value) {
            if (value) {
                this._dateLabel = skynet_store_utilities_1.deserializeMultilingual(value);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisRateComponent.prototype, "datePickerData", {
        get: function () {
            return this._date;
        },
        set: function (date) {
            if (skynet_store_utilities_1.notNil(date)) {
                date = new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000 // to UTC date
                );
            }
            this._date = date;
            this.accountingState.updateDate(date);
        },
        enumerable: true,
        configurable: true
    });
    SisRateComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.localeInfo$ = this.formattingService.getCurrentLocale();
        var selectedCurrencyId$ = this.accountingState.getMoney().pipe(operators_1.map(function (m) { return m.currencyId; }), operators_1.distinctUntilChanged(), operators_1.filter(skynet_store_utilities_1.notNil), utilities_1.simpleDebug(this.logger, 'selectedCurrencyId$ %O'));
        this.formattedRateDate$ = this.accountingState.getAccounting().pipe(operators_1.map(function (accounting) { return accounting.accountingDate; }), operators_1.switchMap(function (date) {
            if (lodash_1.isNil(date)) {
                return of_1.of('');
            }
            return _this.formattingService.formatDate(date.getTime());
        }));
        var formattedRate$ = this.accountingState.getAccounting().pipe(operators_1.map(function (state) { return state.rateToDefault; }), operators_1.switchMap(function (actualRate) {
            if (lodash_1.isNil(actualRate)) {
                return '';
            }
            return _this.formattingService.formatNumber(actualRate, {
                fractionDigits: rate_input_component_1.FRACTION_DIGITS,
            });
        }), utilities_1.simpleDebug(this.logger, 'formattedRate$ %O'));
        var defaultCurrency$ = skynet_store_currencies_api_1.getDefaultCurrency(this.store);
        this.rateAsString$ = combineLatest_1.combineLatest(selectedCurrencyId$.pipe(operators_1.filter(skynet_store_utilities_1.notNil), operators_1.switchMap(function (id) { return _this.getCurrency(id); }), operators_1.filter(skynet_store_utilities_1.notNil)), formattedRate$, defaultCurrency$).pipe(operators_1.map(function (_a) {
            var currency = _a[0], rate = _a[1], defaultCurrency = _a[2];
            return "1 " + defaultCurrency.abbreviation + " = " + rate + " " + currency.abbreviation;
        }), utilities_1.simpleDebug(this.logger, 'rateReadOnlyData$ %O'));
        this.rateHint$ = defaultCurrency$.pipe(operators_1.switchMap(function (currencyRate) {
            return _this.translationService.translate('de.accounting.rate_hint', '', [currencyRate.abbreviation]);
        }), operators_1.publishReplay(1), operators_1.refCount());
        combineLatest_1.combineLatest(defaultCurrency$, selectedCurrencyId$)
            .pipe(operators_1.takeUntil(this.destructionSubject))
            .subscribe(function (_a) {
            var defaultCurrency = _a[0], accounting = _a[1];
            _this.withRateComponent = defaultCurrency.id !== accounting;
            _this.cd.detectChanges();
        }, function (e) { return _this.logger.error(e); });
        this.accountingState
            .getAccounting()
            .pipe(operators_1.map(function (accounting) { return accounting.accountingDate; }))
            .subscribe(function (date) {
            if (lodash_1.isNil(date)) {
                throw new Error("Date can't be null");
            }
            _this._date = date;
            _this.cd.detectChanges();
        }, function (e) { return _this.logger.error(e); });
    };
    SisRateComponent.prototype.ngOnDestroy = function () {
        this.destructionSubject.next();
        this.destructionSubject.complete();
    };
    SisRateComponent.prototype.getCurrency = function (currencyId) {
        var _this = this;
        return skynet_store_currencies_api_1.currencyStoreManager.selectOne(this.store, currencyId).pipe(operators_1.map(function (currency) {
            if (lodash_1.isNil(currency)) {
                _this.logger.error('Cannot find currency by id %O', currencyId);
                throw Error('Cannot find currency');
            }
            return currency;
        }));
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", currency_control_state_1.CurrencyControlState)
    ], SisRateComponent.prototype, "accountingState", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], SisRateComponent.prototype, "id", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], SisRateComponent.prototype, "rateDateReadOnly", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], SisRateComponent.prototype, "rateReadOnly", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], SisRateComponent.prototype, "rateLabel", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], SisRateComponent.prototype, "dateLabel", null);
    SisRateComponent = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'sis-rate',
            template: require('./sis-rate.component.html'),
            styles: [require('./sis-rate.component.css')],
            changeDetection: core_1.ChangeDetectionStrategy.OnPush,
        }),
        __metadata("design:paramtypes", [store_1.Store,
            idm_frontend_shared_1.FormattingService,
            idm_frontend_shared_1.TranslationService,
            core_1.ChangeDetectorRef])
    ], SisRateComponent);
    return SisRateComponent;
}());
exports.SisRateComponent = SisRateComponent;
//# sourceMappingURL=sis-rate.component.js.map